var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GmapMap',{ref:"mapRef",attrs:{"center":{lat: _vm.addressData.latitude, lng: _vm.addressData.longitude},"zoom":13,"options":_vm.mapOptions}},[_c('GmapMarker',{attrs:{"position":{lat: _vm.addressData.latitude, lng: _vm.addressData.longitude},"icon":_vm.stopIcon}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }